import './style.css';

import React from 'react';

class DataSourceMenu extends React.Component {
  render() {
    let nav = null;
    if (!this.props.hideHeader) {
      if (this.props.onNavigate) {
        nav = (
          <h4
            className="data-source-header"
            onClick={this.props.onNavigate.bind(this, 'datasource')}
          >
            <i className="fa fa-chevron-left" />
            <span>{this.props.label}</span>
          </h4>
        );
      } else {
        nav = (
          <h4 className="data-source-header">
            <span>{this.props.label}</span>
          </h4>
        );
      }
    }
    return (
      <div className="data-source">
        <div className="data-source-menu">
          {nav}
          <div>{this.props.children}</div>
        </div>
      </div>
    );
  }
}

class DataSourceMenuItem extends React.Component {
  render() {
    let { icon, next } = this.props;
    let content = [
      <span key="content">
        {this.props.label}
        <br />
        <small>{this.props.children}</small>
      </span>
    ];

    if (!!icon) content.unshift(<i key="icon" className={`fa ${icon}`} />);

    if (!!next) content.push(<i key="next" className="fa fa-chevron-right" />);

    return (
      <div className="data-source-item" onClick={this.props.onClick}>
        {content}
      </div>
    );
  }
}

DataSourceMenuItem.defaultProps = {
  onClick: () => {}
};

export { DataSourceMenu, DataSourceMenuItem };
